import moment from 'moment'

const getFormatDate = value => (value ? moment(value, 'YYYY-MM-DD').format('MM/DD/YYYY') : '')
const setFormatDate = value => moment(value, 'MM/DD/YYYY').format('YYYY-MM-DD')


const disabledDateBySettings = (date, fieldSettings) => {
  if (!fieldSettings) return false

  const restrictionType = fieldSettings.restrictionType

  if (restrictionType === 'today_only') {
    const today = new Date()
    return date.toDateString() !== today.toDateString()
  }

  if (restrictionType === 'future_only') {
    const today = new Date()
    return date < today.setHours(23,59,59,999)
  }

  if (restrictionType === 'past_only') {
    const today = new Date()
    return date >= today.setHours(0,0,0,0)
  }

  if (restrictionType === 'today_and_future') {
    const today = new Date()
    return date < today.setHours(0,0,0,0)
  }

  if (restrictionType === 'today_and_past') {
    const today = new Date()
    return date > today.setHours(23,59,59,999)
  }

  if (restrictionType === 'custom_range') {
    const { startDate, endDate } = fieldSettings.customRange
    const start = startDate ? new Date(startDate) : null
    const end = endDate ? new Date(endDate) : null
    if (start && date < start) return true
    if (end && date > end) return true
    return false
  }

  if (restrictionType === 'relative_range') {
    let { direction, days } = fieldSettings.relativeRange
    days = Number(days) || 0
    const today = new Date()
    today.setHours(0,0,0,0)
    const limitDate = new Date(today)
    if (direction === 'future') limitDate.setDate(today.getDate() + days)
    if (direction === 'past') limitDate.setDate(today.getDate() - days)

    if (direction === 'future') return date > limitDate || date < today
    if (direction === 'past') return date < limitDate || date > today
  }

  if (restrictionType === 'weekdays_only') {
    const day = date.getDay() // 0 = Sunday, 1 = Monday...
    return day === 0 || day === 6 // disable Saturday и Sunday
  }

  if (restrictionType === 'specific_weekdays') {
    const allowedDays = fieldSettings.specificWeekdays ?? [] // ['monday', 'friday']
    const dayNames = ['sunday','monday','tuesday','wednesday','thursday','friday','saturday']
    const day = dayNames[date.getDay()]
    return !allowedDays.includes(day)
  }

  return false // without restrictions
}

export {
  getFormatDate,
  setFormatDate,
  disabledDateBySettings,
}
